import { Turbo } from "@hotwired/turbo-rails"

const ROSTER_FRAME_ID = "hub_team_list"

// The Team page's bulk actions all act on whatever the roster-selection controller currently
// holds, which may be "everything matching these filters" rather than a list of ticked rows.
export function rosterSelection(controller) {
  const element = controller.element.closest('[data-controller~="roster-selection"]')
    || controller.element.querySelector('[data-controller~="roster-selection"]')
    || document.querySelector('[data-controller~="roster-selection"]')

  if (!element) return null

  return controller.application.getControllerForElementAndIdentifier(element, "roster-selection")
}

export function selectionFormData(controller) {
  const formData = new FormData()
  rosterSelection(controller)?.appendTo(formData)
  return formData
}

export function selectedMemberCount(controller) {
  return rosterSelection(controller)?.selectedCount() ?? 0
}

// A bulk action can change rows the browser has never rendered, so the roster is re-fetched from
// the server rather than patched in place.
export function reloadRoster(controller) {
  rosterSelection(controller)?.clear()
  Turbo.visit(window.location.href, { frame: ROSTER_FRAME_ID, action: "replace" })
}
